(() => {
  const URL_PARAM = 'cart-drawer-open';
  const STYLE_ID = 'bb-recharge-cart-bridge-styles';
  const FOOTER_BRIDGE_ID = 'bb-recharge-cart-footer-bridge';
  const EMPTY_BRIDGE_ID = 'bb-recharge-cart-empty-bridge';
  const ERROR_ID = 'bb-recharge-cart-errors';
  const SUCCESS_ID = 'bb-recharge-success-banner';
  const UPSELL_ID = 'bb-recharge-drawer-upsell';
  const PAYMENTS_ID = 'bb-recharge-drawer-payments';
  const OPEN_CLASS = 'overflow-hidden';
  const ORDER_LIMIT_TEXT = 'ORDER NOT VALID';
  const FEE_SKU = 'FEE';
  const FEE_RELOAD_KEY = 'bb-recharge-fee-reloaded-at';
  const FEE_RELOAD_THROTTLE = 10000;
  const config = window.BlackBuffaloRechargeCartBridgeConfig || {};
  let observerStarted = false;
  let scheduledSync = null;
  let attemptedOpenFromUrl = false;
  let countryCodePromise;
  let suppressObserver = false;
  let feeCleanupPromise = null;
  let drawerWasOpen = false;

  const BRIDGE_STYLES = `
    #CartSheet {
      max-width: 45rem !important;
      background: #242424 !important;
      color: #fff !important;
      box-shadow: none !important;
    }

    #cart-drawer {
      background: #242424 !important;
      color: #fff !important;
      font-family: "ProximaNova-Regular", sans-serif !important;
      justify-content: flex-start !important;
    }

    [data-state="open"].fixed.inset-0 {
      background-color: rgba(0, 0, 0, 0.5) !important;
    }

    #cart-drawer header {
      border-bottom: 1px solid #fff !important;
    }

    #cart-drawer header > div {
      position: relative !important;
      padding: 1.5rem 2rem !important;
      align-items: center !important;
    }

    #cart-drawer header .dynamic-richtext h2 {
      margin: 0 !important;
      color: #fff !important;
      font-family: "UnitedSansReg-Heavy", sans-serif !important;
      font-size: 2.4rem !important;
      letter-spacing: 0.06em !important;
      line-height: 1.2 !important;
      text-transform: uppercase !important;
    }

    #cart-drawer header button,
    #cart-drawer button,
    #cart-drawer input,
    #cart-drawer select,
    #cart-drawer label,
    #cart-drawer p,
    #cart-drawer span,
    #cart-drawer a {
      color: #fff !important;
      font-family: "ProximaNova-Regular", sans-serif !important;
    }

    #cart-drawer header button {
      background: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      padding: 0 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .flex.flex-col > p.font-semibold {
      font-size: 1.6rem !important;
      text-transform: uppercase !important;
      color: #fff !important;
      font-weight: 400 !important;
      cursor: pointer !important;
      text-align: left !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .flex.flex-col > p.font-semibold:hover {
      text-decoration: underline !important;
      text-underline-offset: 0.3rem !important;
      text-decoration-thickness: 0.2rem !important;
      color: #95712b !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .flex.flex-col > p.font-semibold strong {
      font-family: proxima_nova_rgbold !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > img {
      width: 6rem !important;
      max-width: 6rem !important;
      height: 6.9rem !important;
      max-height: 6.9rem !important;
      object-fit: contain !important;
      flex-shrink: 0 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center {
      display: grid !important;
      grid-template-columns: 6rem minmax(0, 1fr) 10rem !important;
      column-gap: 1.6rem !important;
      align-items: start !important;
      width: 100% !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 {
      display: flex !important;
      flex-direction: row !important;
      width: 100% !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .flex.flex-col {
      display: flex !important;
      flex: 1 1 100% !important;
      flex-direction: column !important;
      gap: 0 !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child {
      display: flex !important;
      grid-column: 2 !important;
      grid-row: 1 !important;
      flex: 1 1 100% !important;
      width: 100% !important;
      min-width: 100% !important;
      max-width: 100% !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      gap: 0.2rem !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .text-right.whitespace-nowrap {
      text-align: left !important;
      white-space: normal !important;
      margin-top: 0 !important;
      width: 100% !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .text-right.whitespace-nowrap > .text-xs.text-right.text-storefront-drawer-accent.font-semibold {
      color: #95712b !important;
      text-align: left !important;
      font-family: "ProximaNova-Regular", sans-serif !important;
      font-size: 1.2rem !important;
      font-weight: 700 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child {
      display: flex !important;
      grid-column: 3 !important;
      grid-row: 1 !important;
      width: auto !important;
      min-width: auto !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 0.4rem !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border {
      align-self: stretch !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > button[data-slot="button"] {
      align-self: center !important;
      width: auto !important;
      min-width: 2.5rem !important;
      min-height: 2.5rem !important;
      padding: 0 !important;
      margin: 0 0.1rem 0.1rem 0 !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      color: #ae8432 !important;
      cursor: pointer !important;
      font-family: "ProximaNova-Regular", sans-serif !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      letter-spacing: 0.06em !important;
      line-height: 1.6 !important;
      text-transform: uppercase !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > button[data-slot="button"] svg {
      display: none !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > button[data-slot="button"]::after {
      content: "REMOVE" !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > button[data-slot="button"]:hover {
      color: #ae8432 !important;
      text-decoration: underline !important;
      text-underline-offset: 0.3rem !important;
      text-decoration-thickness: 0.2rem !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] select[name="selling_plan"] {
      background-color: #333 !important;
      color: #fff !important;
      border-color: #444 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.gap-2.flex-col.items-start.w-full > button[data-slot="button"] {
      text-align: center !important;
      justify-content: center !important;
    }

    #cart-drawer > div:nth-of-type(2) {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border {
      position: relative !important;
      width: 10rem !important;
      min-width: 10rem !important;
      min-height: 3.2rem !important;
      display: flex !important;
      align-items: center !important;
      border: 0 !important;
      border-radius: 0 !important;
      background-color: transparent !important;
      box-shadow: none !important;
      overflow: hidden !important;
      gap: 0 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border::before {
      content: "" !important;
      position: absolute !important;
      inset: 0 !important;
      background: rgb(var(--color-background)) !important;
      box-shadow: var(--inputs-shadow-horizontal-offset, 0) var(--inputs-shadow-vertical-offset, 0) var(--inputs-shadow-blur-radius, 0) rgba(var(--color-base-text), var(--inputs-shadow-opacity, 0)) !important;
      z-index: 0 !important;
      pointer-events: none !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border::after {
      content: "" !important;
      position: absolute !important;
      top: var(--inputs-border-width, 1px) !important;
      right: var(--inputs-border-width, 1px) !important;
      bottom: var(--inputs-border-width, 1px) !important;
      left: var(--inputs-border-width, 1px) !important;
      border: 0.1rem solid transparent !important;
      border-radius: 0 !important;
      box-shadow: 0 0 0 var(--inputs-border-width, 1px) #444 !important;
      transition: box-shadow var(--duration-short, 0s) ease !important;
      pointer-events: none !important;
      z-index: 1 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"] {
      width: 3.2rem !important;
      min-width: 3.2rem !important;
      height: 3.2rem !important;
      min-height: 3.2rem !important;
      flex-shrink: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 0 !important;
      background: #333 !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      color: rgb(var(--color-foreground)) !important;
      cursor: pointer !important;
      opacity: 1 !important;
      z-index: 2 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"]:hover,
    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"]:focus,
    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"]:focus-visible,
    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"]:active {
      background: #333 !important;
      color: rgb(var(--color-foreground)) !important;
      box-shadow: none !important;
      outline: 0 !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"][aria-disabled="true"] {
      cursor: not-allowed !important;
      opacity: 1 !important;
      color: rgb(var(--color-foreground)) !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"]:first-of-type {
      margin-left: var(--inputs-border-width, 1px) !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"]:last-of-type {
      margin-right: var(--inputs-border-width, 1px) !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"] svg {
      width: 2.1rem !important;
      height: 2.1rem !important;
      pointer-events: none !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > button[data-slot="button"] svg circle {
      display: none !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > input[name="quantity"] {
      color: currentColor !important;
      font-size: 1.4rem !important;
      font-weight: 500 !important;
      text-align: center !important;
      background-color: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
      padding: 0 0.5rem !important;
      width: 100% !important;
      min-width: 0 !important;
      height: 3.2rem !important;
      flex-grow: 1 !important;
      box-shadow: none !important;
      outline: 0 !important;
      z-index: 2 !important;
      -webkit-appearance: none !important;
      appearance: none !important;
    }

    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > input[name="quantity"]:focus,
    #cart-drawer section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :last-child > .flex.items-center.rounded-storefront-drawer.border.border-storefront-drawer-border > input[name="quantity"]:focus-visible {
      background-color: rgb(var(--color-background)) !important;
      box-shadow: none !important;
      outline: 0 !important;
      z-index: 2 !important;
    }

    #cart-drawer footer {
      border-top: 1px solid #fff !important;
      background: #242424 !important;
      box-shadow: none !important;
      padding: 1.5rem !important;
    }

    #cart-drawer footer[style] {
      background-color: #242424 !important;
    }

    #cart-drawer footer > div:first-child {
      padding: 0 1rem 0.4rem !important;
    }

    #cart-drawer footer > div:last-child {
      padding: 0.4rem 1rem 0 !important;
    }

    #cart-drawer footer strong,
    #cart-drawer footer .font-semibold,
    #cart-drawer footer .dynamic-richtext {
      font-family: "proxima_nova_ltsemibold", sans-serif !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;
    }

    #cart-drawer footer > div:first-child [part="money"]:last-of-type::after {
      content: " USD";
    }

    #cart-drawer footer form button[name="checkout"] {
      width: 100% !important;
      min-height: 4.5rem !important;
      border: 1px solid #95712b !important;
      border-radius: 0 !important;
      background-color: #0b6538 !important;
      color: #fff !important;
      cursor: pointer !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      font-family: ProximaNova-Regular, sans-serif !important;
      font-size: 1.8rem !important;
      font-weight: 800 !important;
      letter-spacing: 0.1rem !important;
      line-height: 1.2 !important;
      padding: 0 3rem !important;
      text-decoration: none !important;
      text-transform: uppercase !important;
      transition: background-color 0.15s linear, color 0.15s linear !important;
      box-shadow: none !important;
    }

    #cart-drawer footer form button[name="checkout"]:hover {
      background-color: #fff !important;
      color: #95712b !important;
    }

    .bb-recharge-button,
    .bb-recharge-button {
      width: 100%;
      min-height: 4.5rem;
      border: 1px solid #95712b;
      border-radius: 0;
      background: #242424;
      color: #fff;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      font-weight: 800;
      letter-spacing: 0.1rem;
      line-height: 1.2;
      padding: 0 3rem;
      text-decoration: none;
      text-transform: uppercase;
      transition: background-color 0.15s linear, color 0.15s linear;
    }

    .bb-recharge-button:hover {
      background: #fff;
      color: #95712b;
    }

    #cart-drawer footer form button[name="checkout"]:disabled,
    .bb-recharge-button[disabled] {
      cursor: not-allowed;
      opacity: 0.5;
    }

    .bb-recharge-footer-bridge {
      display: flex;
      flex-direction: column;
      gap: 1.6rem;
      width: 100%;
    }

    .bb-recharge-account-actions {
      display: flex;
      gap: 1.6rem;
      width: 100%;
    }

    #cart-drawer footer .bb-recharge-footer-bridge .bb-recharge-account-actions .bb-recharge-button:first-child {
      background: #0b6538 !important;
      border-color: #0b6538 !important;
    }

    #cart-drawer footer .bb-recharge-footer-bridge .bb-recharge-account-actions .bb-recharge-button:first-child:hover {
      background: #fff !important;
      border-color: #95712b !important;
      color: #95712b !important;
    }

    #cart-drawer footer .bb-recharge-footer-bridge .bb-recharge-account-actions .bb-recharge-button:last-child,
    #cart-drawer footer .bb-recharge-footer-bridge .bb-recharge-account-actions .bb-recharge-button[data-variant="secondary"] {
      background: transparent;
      color: #fff !important;
    }

    #cart-drawer footer .bb-recharge-footer-bridge .bb-recharge-account-actions .bb-recharge-button:last-child:hover,
    #cart-drawer footer .bb-recharge-footer-bridge .bb-recharge-account-actions .bb-recharge-button[data-variant="secondary"]:hover {
      background: transparent !important;
      color: #95712b !important;
      border-color: #95712b !important;
    }

    .bb-recharge-helper-text {
      font-size: 1.4rem;
      line-height: 1.4;
      margin: 0;
      text-align: center;
      text-transform: uppercase;
    }

    .bb-recharge-payments {
      width: 100% !important;
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
      margin-top: 1.2rem !important;
    }

    .bb-recharge-payments > * {
      margin: 0 !important;
    }

    .bb-recharge-payments .payments__title {
      font-size: 1.8rem !important;
      font-family: "proxima_nova_ltsemibold", sans-serif !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;
      color: #fff !important;
    }

    .bb-recharge-payments ul {
      list-style: none !important;
      display: flex !important;
      padding: 0 !important;
      margin: 0 !important;
      gap: 0 !important;
    }

    .bb-recharge-payments ul li {
      padding: 0 !important;
      display: inline-flex !important;
    }

    .bb-recharge-empty-bridge {
      padding: 0 2.4rem 2.4rem;
    }

    #cart-drawer > div.overflow-y-auto.justify-center.items-center > .dynamic-richtext h2 {
      margin: 0 0 5rem !important;
      font-size: calc(var(--font-heading-scale, 1) * 2rem) !important;
      font-family: UnitedSansReg-Heavy !important;
      letter-spacing: 0.06em !important;
      font-style: var(--font-heading-style) !important;
      font-weight: var(--font-heading-weight) !important;
      color: rgb(var(--color-foreground)) !important;
      line-height: calc(1 + 0.3 / max(1, var(--font-heading-scale, 1))) !important;
      word-break: break-word !important;
      text-transform: uppercase !important;
      text-align: center !important;
    }

    #cart-drawer > div.py-4.h-full.overflow-y-auto.flex.flex-col.flex-1.justify-center.items-center button[data-slot="button"] {
      text-transform: uppercase !important;
      background-color: #424243 !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: ProximaNova-Regular, sans-serif !important;
      color: #fff !important;
      font-weight: 800 !important;
      font-size: 1.8rem !important;
    }

    #cart-drawer > div.py-4.h-full.overflow-y-auto.flex.flex-col.flex-1.justify-center.items-center button[data-slot="button"]:hover {
      background-color: #fff !important;
      color: #424243 !important;
    }

    .bb-recharge-empty-login {
      margin-top: 2.5rem;
      font-size: 1.4rem;
      text-align: center;
    }

    #cart-drawer .bb-recharge-empty-login p {
      color: #fffb !important;
      font-size: 16px !important;
      text-transform: uppercase !important;
    }

    .bb-recharge-inline-login {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      padding: 0;
      background: none;
      border: 0;
      cursor: pointer;
      font-size: 1.4rem;
      text-transform: uppercase;
    }

    .bb-recharge-inline-login strong {
      color: #95712b;
      font-family: "ProximaNova-Regular", sans-serif !important;
      border-bottom: 1px solid currentColor;
      font-weight: 400;
    }

    .bb-recharge-error {
      color: #fff !important;
      font-size: 1.4rem !important;
      line-height: 1.4 !important;
      margin: 0;
    }

    .bb-recharge-success-banner {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 0.8rem !important;
      margin: 2rem !important;
      padding: 0.6rem 2rem !important;
      border: 0.1rem solid #95712b !important;
      color: #fff !important;
      text-align: center !important;
    }

    .bb-recharge-success-banner .bb-recharge-success-icon {
      color: #95712b !important;
      font-size: 2.2rem !important;
      line-height: 1 !important;
    }

    .bb-recharge-drawer-upsell {
      border-top: 0.1rem solid #fff !important;
    }

    .bb-recharge-upsell-heading {
      margin: 1.5rem !important;
      text-transform: uppercase !important;
      font-family: "UnitedSansReg-Heavy", sans-serif !important;
      letter-spacing: 0.06em !important;
      color: #fff !important;
      font-size: calc(var(--font-heading-scale, 1) * 2.4rem) !important;
      line-height: 1.2 !important;
    }

    @media screen and (max-width: 749px) {
      .bb-recharge-account-actions {
        flex-direction: column;
      }

      .bb-recharge-helper-text,
      .bb-recharge-account-actions .bb-recharge-button {
        font-size: 1.4rem;
      }
    }

    @media screen and (min-width: 990px) {
      #cart-drawer > div.overflow-y-auto.justify-center.items-center > .dynamic-richtext h2 {
        margin: 0 0 7rem !important;
        font-size: calc(var(--font-heading-scale, 1) * 2.4rem) !important;
      }
    }
  `;

  function getRechargeHost() {
    return document.getElementById('recharge-storefront-experiences__cart-drawer');
  }

  function getShadowRoot() {
    return getRechargeHost()?.shadowRoot || null;
  }

  function getNativeCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getNativeCheckoutButton() {
    return document.querySelector('#CartDrawer-Checkout') || document.querySelector('cart-drawer button[name="checkout"]');
  }

  function getCartDialog(root) {
    return root?.querySelector('#CartSheet[role="dialog"]') || null;
  }

  function isRechargeDrawerOpen(root) {
    return getCartDialog(root)?.getAttribute('data-state') === 'open';
  }

  function scheduleSync() {
    if (scheduledSync) clearTimeout(scheduledSync);
    scheduledSync = setTimeout(() => {
      scheduledSync = null;
      syncRechargeDrawer();
    }, 80);
  }

  function ensureBridgeStyles(root) {
    if (!root || root.getElementById?.(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = BRIDGE_STYLES;
    root.appendChild(style);
  }

  function syncBodyAndUrl(root) {
    const isOpen = isRechargeDrawerOpen(root);
    const nativeDrawerOpen = document.querySelector('cart-drawer.active') !== null;
    const url = new URL(window.location.href);

    if (isOpen) {
      document.body.classList.add(OPEN_CLASS);
      url.searchParams.set(URL_PARAM, '');
    } else if (!nativeDrawerOpen) {
      document.body.classList.remove(OPEN_CLASS);
      url.searchParams.delete(URL_PARAM);
    }

    window.history.replaceState(null, '', url);
  }

  function openModal(mode) {
    const modal = document.getElementById('loginPopupModal');
    const loginForm = document.getElementById('loginFormContainer');
    const recoveryForm = document.getElementById('recoveryFormContainer');
    const registerForm = document.getElementById('registerFormContainer');

    if (!modal || !loginForm || !recoveryForm || !registerForm) return;

    modal.style.display = 'flex';
    loginForm.style.display = mode === 'register' ? 'none' : 'block';
    registerForm.style.display = mode === 'register' ? 'block' : 'none';
    recoveryForm.style.display = 'none';
  }

  function createButton(label, variant = 'primary') {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bb-recharge-button';
    if (variant === 'secondary') {
      button.dataset.variant = 'secondary';
    }
    button.textContent = label;
    return button;
  }

  function triggerNativeOrderLimitModal() {
    const nativeCheckoutButton = getNativeCheckoutButton();
    if (nativeCheckoutButton && typeof nativeCheckoutButton.click === 'function') {
      nativeCheckoutButton.click();
      return;
    }

    const nativeForm = document.querySelector('#CartDrawer-Form');
    if (nativeForm && typeof nativeForm.requestSubmit === 'function') {
      nativeForm.requestSubmit();
    }
  }

  function syncOrderLimitCheckout(root, invalid) {
    const checkoutButton = root?.querySelector('footer form button[name="checkout"]');
    if (!checkoutButton) return;

    if (!checkoutButton.dataset.bbRechargeCheckoutLabel) {
      checkoutButton.dataset.bbRechargeCheckoutLabel = checkoutButton.textContent.trim();
    }

    const existingHandler = checkoutButton._bbRechargeOrderLimitHandler;
    if (existingHandler) {
      checkoutButton.removeEventListener('click', existingHandler);
      delete checkoutButton._bbRechargeOrderLimitHandler;
    }

    if (!invalid) {
      checkoutButton.textContent = checkoutButton.dataset.bbRechargeCheckoutLabel;
      checkoutButton.removeAttribute('aria-disabled');
      return;
    }

    checkoutButton.textContent = ORDER_LIMIT_TEXT;
    checkoutButton.setAttribute('aria-disabled', 'true');

    const handler = (event) => {
      event.preventDefault();
      event.stopPropagation();
      triggerNativeOrderLimitModal();
    };

    checkoutButton._bbRechargeOrderLimitHandler = handler;
    checkoutButton.addEventListener('click', handler);
  }

  function syncHeader(root) {
    const nativeHeading = getNativeCartDrawer()?.querySelector('.drawer__heading')?.textContent?.trim();
    const targetHeading = root?.querySelector('#cart-drawer header .dynamic-richtext h2');
    if (!targetHeading) return;

    targetHeading.textContent = nativeHeading || 'Review Your Cart';
  }

  function syncSuccessBanner(root) {
    const scrollContainer = root?.querySelector('#cart-drawer > div.overflow-y-auto');
    const nativeDrawer = getNativeCartDrawer();
    const nativeBanner = nativeDrawer?.querySelector('.drawer__new-product');
    const shouldShow = nativeDrawer?.classList.contains('add-new-product');
    const existingBanner = scrollContainer?.querySelector(`#${SUCCESS_ID}`);

    if (!scrollContainer) return;

    if (!shouldShow || !nativeBanner) {
      existingBanner?.remove();
      return;
    }

    if (existingBanner) return;

    const banner = document.createElement('div');
    banner.id = SUCCESS_ID;
    banner.className = 'bb-recharge-success-banner';

    const icon = document.createElement('span');
    icon.className = 'bb-recharge-success-icon';
    icon.textContent = '✓';

    const text = document.createElement('span');
    text.textContent = nativeBanner.textContent.trim();

    banner.append(icon, text);
    scrollContainer.insertBefore(banner, scrollContainer.firstChild);
  }

  function massageLineItems(root) {
    const titles = root?.querySelectorAll(
      'section[role="list"] [role="listitem"] > .flex.items-center > .w-full.text-sm.flex.flex-col.gap-2 > :first-child > .flex.flex-col > p.font-semibold'
    );
    if (!titles?.length) return root;

    titles.forEach((titleNode) => {
      if (!titleNode) return;

      const text = titleNode.textContent?.trim();
      if (!text) return;

      const firstSpaceIndex = text.indexOf(' ');
      if (firstSpaceIndex === -1) return;

      const firstWord = text.slice(0, firstSpaceIndex);
      const rest = text.slice(firstSpaceIndex);
      titleNode.innerHTML = `<strong>${firstWord}</strong>${rest}`;
    });

    root
      ?.querySelectorAll('section[role="list"] [role="listitem"] > .flex.gap-2.flex-col.items-start.w-full > button[data-slot="button"] strong')
      .forEach((strongNode) => {
        const parent = strongNode.parentElement;
        if (!parent) return;

        parent.textContent = parent.textContent?.replace(/\s+/g, ' ').trim() || '';
      });

    return root;
  }

  function syncSubtotal(root) {
    const nativeSubtotalLabel = getNativeCartDrawer()?.querySelector('.totals__subtotal')?.textContent?.trim();
    const subtotalLabel = root?.querySelector('#cart-drawer footer .dynamic-richtext strong');

    if (subtotalLabel) {
      subtotalLabel.textContent = nativeSubtotalLabel || 'Subtotal';
    }
  }

  function getNativePayments() {
    return getNativeCartDrawer()?.querySelector('.drawer__payments') || null;
  }

  function syncPayments(root, shouldShow) {
    const actionContainer = root?.querySelector('#cart-drawer footer form')?.parentElement;
    if (!actionContainer) return;

    const existingPayments = actionContainer.querySelector(`#${PAYMENTS_ID}`);

    if (!shouldShow) {
      existingPayments?.remove();
      return;
    }

    const nativePayments = getNativePayments();
    if (!nativePayments) {
      existingPayments?.remove();
      return;
    }

    if (existingPayments) return;

    const payments = nativePayments.cloneNode(true);
    payments.id = PAYMENTS_ID;
    payments.classList.add('bb-recharge-payments');
    actionContainer.appendChild(payments);
  }

  function applyGuestFooter(actionContainer) {
    let bridge = actionContainer.querySelector(`#${FOOTER_BRIDGE_ID}`);
    if (!bridge) {
      bridge = document.createElement('div');
      bridge.id = FOOTER_BRIDGE_ID;
      bridge.className = 'bb-recharge-footer-bridge';

      const actions = document.createElement('div');
      actions.className = 'bb-recharge-account-actions';

      const loginButton = createButton(config.labels?.login || 'Log in');
      loginButton.addEventListener('click', () => openModal('login'));

      const registerButton = createButton(config.labels?.register || 'Create account', 'secondary');
      registerButton.addEventListener('click', () => openModal('register'));

      actions.append(loginButton, registerButton);
      bridge.appendChild(actions);

      if (config.accountText) {
        const helper = document.createElement('p');
        helper.className = 'bb-recharge-helper-text';
        helper.textContent = config.accountText;
        bridge.appendChild(helper);
      }
    }

    actionContainer.appendChild(bridge);
  }

  function applyVerifyFooter(actionContainer) {
    let bridge = actionContainer.querySelector(`#${FOOTER_BRIDGE_ID}`);
    if (!bridge) {
      bridge = document.createElement('div');
      bridge.id = FOOTER_BRIDGE_ID;
      bridge.className = 'bb-recharge-footer-bridge';

      const verifyLink = document.createElement('a');
      verifyLink.className = 'bb-recharge-button';
      verifyLink.href = '/pages/verify-age';
      verifyLink.textContent = config.labels?.verifyAge || 'Verify Age';
      bridge.appendChild(verifyLink);

      if (config.verifyText) {
        const helper = document.createElement('p');
        helper.className = 'bb-recharge-helper-text';
        helper.textContent = config.verifyText;
        bridge.appendChild(helper);
      }
    }

    actionContainer.appendChild(bridge);
  }

  function syncFooterState(root) {
    const footer = root?.querySelector('#cart-drawer footer');
    const actionContainer = footer?.querySelector('form')?.parentElement || footer?.querySelector('div:last-child');
    const form = footer?.querySelector('form');
    const checkoutButton = form?.querySelector('button[name="checkout"]');
    const existingBridge = actionContainer?.querySelector(`#${FOOTER_BRIDGE_ID}`);

    if (!footer || !actionContainer) return;

    if (!config.customerAccountsEnabled) {
      if (form) form.style.display = '';
      existingBridge?.remove();
      syncPayments(root, true);
      return;
    }

    if (!config.customerLoggedIn) {
      if (form) form.style.display = 'none';
      syncPayments(root, false);
      applyGuestFooter(actionContainer);
      return;
    }

    if (!config.customerVerified) {
      if (form) form.style.display = 'none';
      syncPayments(root, false);
      applyVerifyFooter(actionContainer);
      return;
    }

    existingBridge?.remove();
    if (form) form.style.display = '';
    if (checkoutButton) checkoutButton.disabled = false;
    syncPayments(root, true);
  }

  function syncEmptyState(root) {
    const cartDrawer = root?.querySelector('#cart-drawer');
    const items = root?.querySelectorAll('section[role="list"] [role="listitem"]') || [];
    const scrollContainer = cartDrawer?.querySelector('div.overflow-y-auto');

    if (!cartDrawer || !scrollContainer) return;

    const existingBridge = scrollContainer.querySelector(`#${EMPTY_BRIDGE_ID}`);
    if (items.length > 0 || config.customerLoggedIn || !config.customerAccountsEnabled) {
      existingBridge?.remove();
      return;
    }

    if (existingBridge) return;

    const bridge = document.createElement('div');
    bridge.id = EMPTY_BRIDGE_ID;
    bridge.className = 'bb-recharge-empty-bridge';

    const loginWrap = document.createElement('div');
    loginWrap.className = 'bb-recharge-empty-login';

    const title = document.createElement('p');
    title.textContent = config.labels?.loginTitle || 'Already have an account?';

    const loginButton = document.createElement('button');
    loginButton.type = 'button';
    loginButton.className = 'bb-recharge-inline-login';
    loginButton.innerHTML = `<strong>${config.labels?.login || 'Log in'}</strong><span>${config.labels?.loginHelper || 'Log in to check out faster.'}</span>`;
    loginButton.addEventListener('click', () => openModal('login'));

    loginWrap.append(title, loginButton);
    bridge.appendChild(loginWrap);
    scrollContainer.appendChild(bridge);
  }

  async function getCountryCode() {
    if (!countryCodePromise) {
      countryCodePromise = fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .then((json) => fetch(`https://ipapi.co/${json.ip}/country_code/`))
        .then((response) => response.text())
        .then((countryCode) => countryCode.trim())
        .catch(() => 'US');
    }

    return countryCodePromise;
  }

  async function removeCheckoutFeeItems() {
    if (feeCleanupPromise) return feeCleanupPromise;

    feeCleanupPromise = (async () => {
      try {
        const cart = await fetch('/cart.js').then((response) => response.json());
        const feeItems = (cart.items || []).filter(
          (item) => String(item.sku || '').trim().toUpperCase() === FEE_SKU
        );

        if (!feeItems.length) return false;

        for (const item of feeItems) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }

        return true;
      } catch (error) {
        console.error('Recharge cart bridge fee cleanup failed', error);
        return false;
      }
    })();

    feeCleanupPromise.finally(() => {
      setTimeout(() => {
        feeCleanupPromise = null;
      }, 1000);
    });

    return feeCleanupPromise;
  }

  function canReloadAfterFeeCleanup() {
    try {
      const lastReload = parseInt(window.sessionStorage.getItem(FEE_RELOAD_KEY) || '0', 10);
      if (Date.now() - lastReload < FEE_RELOAD_THROTTLE) return false;

      window.sessionStorage.setItem(FEE_RELOAD_KEY, String(Date.now()));
    } catch (error) {
      // sessionStorage unavailable (private mode): fall through and reload once.
    }

    return true;
  }

  async function syncCheckoutFeeItems() {
    const removed = await removeCheckoutFeeItems();
    if (!removed || !canReloadAfterFeeCleanup()) return;

    window.location.reload();
  }

  async function syncCheckoutLock(root) {
    if (!config.customerLoggedIn || !config.customerVerified) return;

    const checkoutButton = root?.querySelector('footer form button[name="checkout"]');
    const actionContainer = root?.querySelector('footer form')?.parentElement;
    if (!checkoutButton || !actionContainer) return;

    let errorNode = actionContainer.querySelector(`#${ERROR_ID}`);
    if (!errorNode) {
      errorNode = document.createElement('p');
      errorNode.id = ERROR_ID;
      errorNode.className = 'bb-recharge-error';
      actionContainer.appendChild(errorNode);
    }

    try {
      const [cartResponse, countryCode] = await Promise.all([fetch('/cart.js'), getCountryCode()]);
      const cart = await cartResponse.json();
      const orderLimitInvalid = cart.item_count > 9;
      let packCount = 0;

      cart.items.forEach((item) => {
        const quantityOption = item.options_with_values?.find((option) => option.name === 'Quantity');
        if (!quantityOption) return;

        const perPackQuantity = parseInt(String(quantityOption.value), 10);
        if (Number.isNaN(perPackQuantity)) return;

        packCount += item.quantity * perPackQuantity;
      });

      const shouldBlock = packCount >= 25 && countryCode !== 'US';
      checkoutButton.disabled = shouldBlock;
      syncOrderLimitCheckout(root, orderLimitInvalid);
      errorNode.textContent = shouldBlock ? 'Maximum for one order is 25 packs.' : '';
    } catch (error) {
      console.error('Recharge cart bridge checkout sync failed', error);
    }
  }

  function syncUpsellSection(root) {
    const cartDrawer = root?.querySelector('#cart-drawer');
    const footer = cartDrawer?.querySelector('footer');
    const body = cartDrawer?.querySelector(':scope > div.overflow-y-auto');
    const nativeUpsell = getNativeCartDrawer()?.querySelector('.drawer__upsell');
    let bridge = cartDrawer?.querySelector(`#${UPSELL_ID}`);

    if (!cartDrawer || !nativeUpsell) {
      bridge?.remove();
      return;
    }

    if (!bridge) {
      bridge = document.createElement('div');
      bridge.id = UPSELL_ID;
      bridge.className = 'bb-recharge-drawer-upsell';
    }

    if (footer) {
      if (footer.nextElementSibling !== bridge) {
        footer.insertAdjacentElement('afterend', bridge);
      }
    } else if (body) {
      if (body.nextElementSibling !== bridge) {
        body.insertAdjacentElement('afterend', bridge);
      }
    } else if (cartDrawer.lastElementChild !== bridge) {
      cartDrawer.appendChild(bridge);
    }

    bridge.innerHTML = '';
    const heading = document.createElement('div');
    heading.className = 'bb-recharge-upsell-heading';
    heading.textContent = nativeUpsell.querySelector('.drawer__heading')?.textContent?.trim() || 'Charge Ahead';
    bridge.appendChild(heading);
  }

  function tryOpenFromUrl(root) {
    if (attemptedOpenFromUrl) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.has(URL_PARAM) || isRechargeDrawerOpen(root)) return;

    attemptedOpenFromUrl = true;
    const cartTrigger = document.getElementById('cart-icon-bubble');
    if (cartTrigger) {
      cartTrigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  }

  function syncRechargeDrawer() {
    const root = getShadowRoot();
    if (!root) return;

    suppressObserver = true;

    const drawerOpen = isRechargeDrawerOpen(root);
    if (drawerOpen && !drawerWasOpen) syncCheckoutFeeItems();
    drawerWasOpen = drawerOpen;

    ensureBridgeStyles(root);
    syncHeader(root);
    syncSuccessBanner(root);
    massageLineItems(root);
    syncSubtotal(root);
    syncBodyAndUrl(root);
    syncFooterState(root);
    syncEmptyState(root);
    syncCheckoutLock(root);
    syncUpsellSection(root);
    tryOpenFromUrl(root);

    requestAnimationFrame(() => {
      suppressObserver = false;
    });
  }

  function observeShadowRoot(root) {
    const host = getRechargeHost();
    if (!root || !host || host.dataset.bbRechargeObserved) return;

    host.dataset.bbRechargeObserved = 'true';
    const shadowObserver = new MutationObserver(() => {
      if (suppressObserver) return;
      scheduleSync();
    });

    shadowObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state', 'class']
    });
  }

  function startObserver() {
    if (observerStarted) return;

    observerStarted = true;
    const initialRoot = getShadowRoot();
    if (initialRoot) {
      ensureBridgeStyles(initialRoot);
      observeShadowRoot(initialRoot);
    }

    const pageObserver = new MutationObserver(() => {
      const root = getShadowRoot();
      if (!root) return;

      ensureBridgeStyles(root);
      observeShadowRoot(root);
      scheduleSync();
    });

    pageObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncCheckoutFeeItems();
    startObserver();
    scheduleSync();
  });
})();
